module.exports = __webpack_public_path__ + "static/img/empty.ceebc9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/empty.png
// module id = vTAX
// module chunks = 0